import { teamEventsForMetricAtom } from '@/atoms/queries/team/teamEventData';
import { TEAM_PREVIEW_EVENT_KEYS, PreviewEvents } from '@/components/tables/PreviewEvents';

export const TeamPreviewEvents = () => (
  <PreviewEvents eventsAtom={teamEventsForMetricAtom} eventKeys={TEAM_PREVIEW_EVENT_KEYS} />
);
